  $( document ).ready(function() {
        $("button.custom-wishlist").each(function(){
          $(this).appendTo($(this).parent().parent().find(".ProductIem_ImageContainer"));
      });
    });
function changeVideoSource(x, vid, smallVideoUrl, largeVideoUrl) {
    if (x.matches) { // If media query matches
        if(smallVideoUrl != ''){
            vid.src = smallVideoUrl;
        } else {
            vid.src = largeVideoUrl;
        }
        vid.load();
    } else {
        vid.src = largeVideoUrl;
        vid.load();
    }
}